/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleEvaluationRequestTaskEvaluations } from './moduleEvaluationRequestTaskEvaluations';
import type { ModuleEvaluationRequestGrading } from './moduleEvaluationRequestGrading';

/**
 * Request to evaluate a module submission with task evaluations and grading
 */
export interface ModuleEvaluationRequest {
  taskEvaluations?: ModuleEvaluationRequestTaskEvaluations;
  grading?: ModuleEvaluationRequestGrading;
  /** Whether to submit the evaluation to the student. If false, saves the evaluation as a draft. */
  submitToStudent?: boolean;
}
